import { render, staticRenderFns } from "./IncomesAddEdit.vue?vue&type=template&id=ef9751a4&scoped=true"
import script from "./IncomesAddEdit.vue?vue&type=script&lang=js"
export * from "./IncomesAddEdit.vue?vue&type=script&lang=js"
import style0 from "./IncomesAddEdit.vue?vue&type=style&index=0&id=ef9751a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9751a4",
  null
  
)

export default component.exports